import { render, staticRenderFns } from "./LessonplanMedia.vue?vue&type=template&id=3e8b0218&"
import script from "./LessonplanMedia.vue?vue&type=script&lang=js&"
export * from "./LessonplanMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports